<script>
import {onMount} from 'svelte';
import Liquid from 'liquidjs';


import {Input, Textarea, Button} from '../components/ui';

let engine = new Liquid.Liquid();
let text;
let liquidText = `Hello I'm {{name | capitalize}} and live in {{city | upcase}} since I'm {{age}} years old`;
let vars = {
    name: 'Annika',
    age: '31',
    city: 'Prague'
}
onMount(()=>{
    compileText();
})

function compileText(){
    console.log(liquidText);
 engine
    .parseAndRender(liquidText, {name: vars.name, age: vars.age, city: vars.city})
    .then((res)=>{text = res});    

    // Eigene Filter
}


</script>
<div class="p-4">
    <div class="flex flex-row">
        <Textarea bind:model={liquidText} label="Write some liquid - use vars name, age and city" class="w-2/3 p-2" />
        <div class="w-1/3 p-2">
            <Input bind:model={vars.name} label="name" />
            <Input bind:model={vars.age} label="age" />
            <Input bind:model={vars.city} label="city" />

        </div>
    </div>
    <Button class="mt-2 mb-4" on:submit={()=>{compileText()}} primary={true}>Compile Text</Button>
    <p>Output</p>
    <p class="font-bold">{text}</p>
</div>
